import { Box, Container, Flex, Heading, Text } from "@chakra-ui/react";
import type { Product } from "../types";
import Carousel from "./Carousel";
import ProductCard from "./ProductCard";

interface ProductCarouselProps {
  title: string;
  products: Product[];
}

const ProductCarousel = ({ title, products }: ProductCarouselProps) => {
  if (products.length === 0) return null;

  return (
    <Box as="section" py={12}>
      <Container maxW="container.xl" px={{ base: 4, md: 6 }}>
        <Flex align="flex-end" justify="space-between" mb={6}>
          <Box>
            <Text
              fontSize="10.5px"
              fontWeight="500"
              letterSpacing="0.14em"
              textTransform="uppercase"
              color="rs.red"
              mb="7px"
            >
              Special offers
            </Text>
            <Heading
              fontFamily="'DM Serif Display', serif"
              fontSize={{ base: "22px", md: "26px" }}
              fontWeight="400"
              color="rs.text"
            >
              {title}
            </Heading>
          </Box>
        </Flex>

        <Carousel
          showArrows={products.length > 3}
          options={{ loop: false, align: "start" }}
        >
          {products.map((product) => (
            <Box
              key={product.id}
              flex="0 0 auto"
              w={{ base: "78%", sm: "46%", md: "31%", lg: "23%" }}
              pr={4}
            >
              <ProductCard product={product} />
            </Box>
          ))}
        </Carousel>
      </Container>
    </Box>
  );
};

export default ProductCarousel;
